<template>
  <Head
    :title="
      t('page.title', {
        clientId: ltiRegistration.clientId,
      })
    "
  />
  <s-page-block size="md" class="flex-1">
    <s-page-header
      class="mb-5"
      :heading="
        t('page.title', {
          clientId: ltiRegistration.clientId,
        })
      "
    ></s-page-header>

    <s-form-inline
      v-model="form.lmsIssuedDeploymentId"
      :placeholder="t('form.lmsIssuedDeploymentId')"
      @submit="
        form.post(
          route('institutions.lti-registrations.lti-deployments.store', {
            institution: institution.id,
            ltiRegistration: ltiRegistration.id,
          }),
          {
            onSuccess() {
              form.reset();
            },
          }
        )
      "
      :submitLabel="t('actions.add')"
      :processing="form.processing"
      icon="plus"
      class="mb-3"
    />
    <table class="table">
      <thead>
        <tr>
          <th class="w-0">{{ t('table.identifier') }}</th>
          <th class="w-0">{{ t('table.createdBy') }}</th>
          <th>{{ t('table.createdAt') }}</th>
          <th class="w-0"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="deployment in ltiDeployments">
          <td>{{ deployment.lmsIssuedDeploymentId }}</td>
          <td>{{ deployment.createdByEmail }}</td>
          <td>
            {{ monthDayYear(deployment.createdAt.date) }} {{ timeOfDay(deployment.createdAt.date) }}
          </td>
          <td>
            <s-btn
              size="sm"
              color="red-light"
              icon="trash-can"
              method="delete"
              :href="
                route('institutions.lti-registrations.lti-deployments.destroy', {
                  institution: institution.id,
                  ltiRegistration: ltiRegistration.id,
                  ltiDeployment: deployment.id,
                })
              "
              class="w-fit"
            >
              {{ t('actions.delete') }}
            </s-btn>
          </td>
        </tr>
        <tr v-if="!ltiDeployments.length">
          <td colspan="4" class="text-center">{{ t('table.noData') }}</td>
        </tr>
      </tbody>
    </table>
  </s-page-block>
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import SPageBlock from '../../../design-system/SPageBlock.vue';
import SBtn from '../../../design-system/SBtn.vue';
import SFormInline from '../../../design-system/SFormInline.vue';
import {Head, InertiaForm, useForm} from '@inertiajs/vue3';
import {route} from 'ziggy-js';
import {Institution} from '../../../types/entities/institution';
import {monthDayYear, timeOfDay} from '../../../format/dates';
import SPageHeader from '../../../design-system/SPageHeader.vue';
import {LaravelDate} from '../../../types/laravel-date';

const props = defineProps<{
  institution: Institution;
  ltiRegistration: {id: number; clientId: string};
  ltiDeployments: {
    id: number;
    lmsIssuedDeploymentId: number;
    createdAt: LaravelDate;
    createdByEmail: string;
  }[];
}>();

const {t} = useI18n();

const form = useForm({
  lmsIssuedDeploymentId: '',
});
</script>
<i18n>
{
  "en": {
    "page": {
      "title": "Edit Deployments for Registration - {clientId}"
    },
    "form": {
      "lmsIssuedDeploymentId": "Enter the Deployment ID from your LMS"
    },
    "table": {
      "identifier": "Deployment ID",
      "createdBy": "Created By",
      "createdAt": "Created At",
      "noData": "No LTI Deployments have been added yet."
    }
  },
  "fr": {
    "page": {
      "title": "Modifier les déploiements pour l'inscription - {clientId}"
    },
    "form": {
      "lmsIssuedDeploymentId": "Entrez l'ID de déploiement de votre LMS"
    },
    "table": {
      "identifier": "ID de déploiement",
      "createdBy": "Créé par",
      "createdAt": "Créé à",
      "noData": "Aucun déploiement LTI n'a encore été ajouté."
    }
  }
}
</i18n>
